import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ShieldAlert, X, Clock } from "lucide-react";

export function SupportAccessBanner() {
  const [sessions, setSessions] = useState([]);

  const load = () => api.get("/support/access/active").then((r) => setSessions(r.data.sessions || [])).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const revoke = async (id) => {
    try { await api.post(`/support/access/${id}/revoke`); toast.success("Accès révoqué"); load(); }
    catch { toast.error("Erreur"); }
  };

  if (!sessions.length) return null;
  return (
    <div className="space-y-2" data-testid="support-access-banner">
      {sessions.map((s) => (
        <div key={s.id} className="flex flex-wrap items-center gap-3 px-4 py-2.5 rounded-xl"
          style={{ background: "color-mix(in srgb, #F10D19 12%, transparent)", border: "1px solid rgba(241,13,25,0.5)" }}>
          <ShieldAlert size={18} className="text-[#F10D19] shrink-0" />
          <div className="flex-1 min-w-[200px]">
            <p className="text-sm font-bold text-white">MODE SUPPORT PROGÈRE</p>
            <p className="text-xs text-gray-300">
              {s.technician_name} consulte temporairement votre compte pour le billet <b>{s.ticket_number}</b>
              {s.reason ? ` — ${s.reason}` : ""}.
            </p>
            <p className="text-[11px] text-gray-400 flex items-center gap-1 mt-0.5">
              <Clock size={11} /> Expire : {String(s.expires_at || "").slice(0, 16).replace("T", " ")}
            </p>
          </div>
          <button onClick={() => revoke(s.id)} data-testid={`revoke-access-${s.id}`}
            className="flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full text-white" style={{ background: "#F10D19" }}>
            <X size={13} /> Révoquer l'accès
          </button>
        </div>
      ))}
    </div>
  );
}
